var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 151,
    viewBox: "0 0 127 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.3757 43.3299C94.3757 43.3299 98.4376 103.671 61.8858 103.671C25.3353 103.671 28.2689 43.3299 28.2689 43.3299C28.2689 43.3299 26.5034 7.44484 63.1246 7.44484C97.2073 7.44484 94.3757 43.3299 94.3757 43.3299Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 1.61269,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3654 55.2369C94.3654 55.2369 97.7874 50.2998 101.847 52.6949C105.907 55.0885 104.614 63.9284 101.847 68.3497C99.0786 72.7696 94.6104 74.9542 92.1398 71.5601",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3654 55.2369C94.3654 55.2369 97.7874 50.2998 101.847 52.6949C105.907 55.0885 104.614 63.9284 101.847 68.3497C99.0786 72.7696 94.6104 74.9542 92.1398 71.5601",
    stroke: "#1A1A1A",
    strokeWidth: 1.61269,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.402 58.2204C101.402 58.2204 96.8277 56.6971 93.5813 63.4203",
    stroke: "#1A1A1A",
    strokeWidth: 0.807051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8019 60.1308C95.8019 60.1308 100.78 62.7887 97.4909 66.7819",
    stroke: "#1A1A1A",
    strokeWidth: 0.807051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5137 55.2369C28.5137 55.2369 25.0917 50.2998 21.0326 52.6949C16.9735 55.0885 18.2647 63.9284 21.0326 68.3497C23.8005 72.7696 28.2688 74.9542 30.7408 71.5601",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5137 55.2369C28.5137 55.2369 25.0917 50.2998 21.0326 52.6949C16.9735 55.0885 18.2647 63.9284 21.0326 68.3497C23.8005 72.7696 28.2688 74.9542 30.7408 71.5601",
    stroke: "#1A1A1A",
    strokeWidth: 1.61269,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4769 58.2204C21.4769 58.2204 26.0514 56.6971 29.2993 63.4203",
    stroke: "#1A1A1A",
    strokeWidth: 0.807051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.078 60.1308C27.078 60.1308 22.1 62.7887 25.3889 66.7819",
    stroke: "#1A1A1A",
    strokeWidth: 0.807051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7314 54.1006V66.7513C59.7314 67.1442 59.8079 67.5214 59.9466 67.8676C60.4903 69.2255 62.0562 69.8755 63.472 69.4997L66.516 68.6914",
    stroke: "#1A1A1A",
    strokeWidth: 1.52662,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8133 34.0416C56.5486 34.4372 54.96 39.4548 54.96 39.4548H37.4989L43.4269 36.1003C44.929 35.35 46.5615 34.8936 48.2364 34.7537L56.8133 34.0416Z",
    fill: "#1A1A1A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8203 34.0416C68.0851 34.4372 69.6736 39.4548 69.6736 39.4548H87.1347L81.2068 36.1003C79.7046 35.35 78.0722 34.8936 76.3973 34.7537L67.8203 34.0416Z",
    fill: "#1A1A1A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0761 51.351C51.0761 53.0212 49.7197 54.3763 48.0448 54.3763C46.3714 54.3763 45.015 53.0212 45.015 51.351C45.015 49.6808 46.3714 48.3257 48.0448 48.3257C49.7197 48.3257 51.0761 49.6808 51.0761 51.351Z",
    fill: "#1A1A1A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3183 51.351C79.3183 53.0212 77.9619 54.3763 76.287 54.3763C74.6135 54.3763 73.2572 53.0212 73.2572 51.351C73.2572 49.6808 74.6135 48.3257 76.287 48.3257C77.9619 48.3257 79.3183 49.6808 79.3183 51.351Z",
    fill: "#1A1A1A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.903 75.7229C51.903 75.7229 56.8823 79.1919 62.9151 79.1919C68.9492 79.1919 73.1174 75.7229 73.1174 75.7229",
    stroke: "#1A1A1A",
    strokeWidth: 1.52662,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7722 62.9525C57.7722 69.9582 52.0806 75.6385 45.0611 75.6385C38.0415 75.6385 32.35 69.9582 32.35 62.9525C32.35 55.9467 38.0415 50.2664 45.0611 50.2664C52.0806 50.2664 57.7722 55.9467 57.7722 62.9525Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.754846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9986 62.9525C88.9986 69.9582 83.3071 75.6385 76.2875 75.6385C69.2665 75.6385 63.5764 69.9582 63.5764 62.9525C63.5764 55.9467 69.2665 50.2664 76.2875 50.2664C83.3071 50.2664 88.9986 55.9467 88.9986 62.9525Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.754846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7722 62.8696C57.7722 62.8696 60.7836 60.0648 63.577 62.8696",
    stroke: "#1A1A1A",
    strokeWidth: 0.754846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8304 65.874L28.3466 62.3556",
    stroke: "#1A1A1A",
    strokeWidth: 0.754846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5432 65.874L94.5108 61.1913",
    stroke: "#1A1A1A",
    strokeWidth: 0.754846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3088 0.151886C16.7846 0.151886 21.2812 30.3933 28.053 54.3765C28.053 54.3765 34.0772 43.1953 32.8781 35.3064C58.1714 32.4323 80.8498 18.5225 80.963 18.4533C82.7116 32.2387 94.6652 52.7077 94.6652 52.7077C101.402 30.3933 108.403 0.151886 61.3088 0.151886Z",
    fill: "#1A1A1A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M147.038 181.447C147.038 149.86 110.442 131.384 110.442 131.384H66.5166H59.7307H15.8053C15.8053 131.384 -20.7904 149.86 -20.7904 181.447",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M147.038 181.447C147.038 149.86 110.442 131.384 110.442 131.384H66.5166H59.7307H15.8053C15.8053 131.384 -20.7904 149.86 -20.7904 181.447",
    stroke: "#1A1A1A",
    strokeWidth: 1.61269,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M135.3 151.533H-9.05127L-1.13833 143.335H127.387L135.3 151.533Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5471 93.2457V118.611C39.5471 118.611 34.0891 128.221 15.8054 131.384H109.172C109.172 131.384 85.7575 126.517 84.0557 118.611V93.2457",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5471 93.2457V118.611C39.5471 118.611 34.0891 128.221 15.8054 131.384H109.172C109.172 131.384 85.7575 126.517 84.0557 118.611V93.2457",
    stroke: "#1A1A1A",
    strokeWidth: 1.61269,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M40.038 91.9263C40.038 91.9263 46.6073 104.943 57.2358 110.988C64.9547 115.377 74.9361 113.674 80.1746 106.514C82.7868 102.942 84.7774 97.6857 84.7774 89.9565C84.7774 89.9565 76.2656 101.142 63.5757 101.668C50.8873 102.193 40.038 91.9263 40.038 91.9263Z",
    fill: "#1A1A1A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.5ce6eefe04407f80c00d8eb37d3271b8.svg";
export { ForwardRef as ReactComponent };